var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('FilmTabReport',{attrs:{"loading":_vm.loading,"patient-info":_vm.patientInfo,"image-info":_vm.imageInfo,"title":"名医诊断报告"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }